import React, {useEffect} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {ReceiptsGridContextProvider} from '../../components/ReceiptsGridContext';
import ReceiptsGrid from '../../components/ReceiptsGrid';
import FieldCustomerID from '../../components/FieldCustomerID';
import FieldDateRange from '../../components/FieldDateRange';
import PageHeader from '../../../../common/components/ui/PageHeader';
import FiltersBar from '../../../../common/components/ui/FiltersBar';
import ButtonDownload from '../../components/ButtonDownload';
import StatsPanel from '../../components/StatsPanel';
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from "../../../../common/components/ui/FooterLogo";
import styles from './Receipts.module.scss';

const Receipts = () => {
  const {setPageTitle} = useGlobalContext();
  const {setPopupPanelContent, closePopupPanel} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'receipts-page-header'}
        defaultMessage={'Receipts'}
      />
    ));

    return () => {
      closePopupPanel();
      setPopupPanelContent(null);
    };
  }, []);

  return (
    <ReceiptsGridContextProvider>
      <FiltersBar>
        <div className={styles.filtersContainer}>
          <FieldDateRange/>
          <FieldCustomerID/>
          <div className={styles.buttonDownloadDesktop}>
            <ButtonDownload/>
          </div>
        </div>
      </FiltersBar>
      <div className={styles.statsPanelContainer}>
        <StatsPanel/>
        <div className={styles.buttonDownloadMobile}>
          <ButtonDownload/>
        </div>
      </div>
      <ReceiptsGrid/>
      <FooterDivider/>
      <FooterLogo/>
    </ReceiptsGridContextProvider>
  );
};

export default Receipts;
